import React, { useEffect, useMemo, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  List,
  ListItemButton,
  ListItemText,
  InputAdornment,
  Box,
  Typography,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { Veiculo } from '../types';

interface VeiculoPickerDialogProps {
  open: boolean;
  veiculos: Veiculo[];
  selectedId?: number;
  onClose: () => void;
  onSelect: (veiculo: Veiculo) => void;
}

const VeiculoPickerDialog: React.FC<VeiculoPickerDialogProps> = ({
  open,
  veiculos,
  selectedId,
  onClose,
  onSelect,
}) => {
  const [busca, setBusca] = useState('');

  useEffect(() => {
    if (open) setBusca('');
  }, [open]);

  const filtrados = useMemo(() => {
    const termo = busca.trim().toLowerCase();
    if (!termo) return veiculos;
    return veiculos.filter((v) =>
      [v.placa, v.marca, v.modelo, v.departamentoNome]
        .filter(Boolean)
        .some((campo) => String(campo).toLowerCase().includes(termo))
    );
  }, [busca, veiculos]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Selecionar Veículo</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          autoFocus
          placeholder="Buscar por placa, marca, modelo ou departamento..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <List dense sx={{ maxHeight: 360, overflowY: 'auto', mt: 1 }}>
          {filtrados.map((v) => (
            <ListItemButton
              key={v.id}
              selected={v.id === selectedId}
              onClick={() => onSelect(v)}
            >
              <ListItemText
                primary={`${v.placa} — ${v.marca} ${v.modelo}`}
                secondary={v.departamentoNome || undefined}
              />
            </ListItemButton>
          ))}
          {filtrados.length === 0 && (
            <Box sx={{ p: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Nenhum veículo encontrado.
              </Typography>
            </Box>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default VeiculoPickerDialog;
